import { AdminService } from '@admin/services/admin.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { digger } from '@cbre/digger';
import { DataObject } from '@shared/models/data-object.model';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';
import { LookupRefService } from '@shared/services/lookup-ref.service';

import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'miq-editing-box-field',
  templateUrl: './editing-box-field.component.html',
  styleUrls: ['./editing-box-field.component.scss'],
  standalone: false,
})
export class EditingBoxFieldComponent implements OnInit, OnChanges {
  @Input() record: any;
  @Input() column: any;
  @Input() readColumnValue: any;
  @Output() modified = new EventEmitter<any>();

  OPEX_MONTHLY_YEARLY_COLUMN_ID = 17023;
  value: any;
  values: any[];
  state = '';
  userId: number;
  locationPermission: any;
  userConfidentialityLevel: string;

  constructor(
    private lookupRef: LookupRefService,
    private adminService: AdminService,
    private userInfoResolver: UserInfoResolver
  ) {}

  ngOnInit() {
    const { field } = this.column;
    this.value = digger(this.record, field);
    this.getLocationPermission();
    if (this.isDropdown) {
      this.setUpDropdowns();
    }
  }

  ngOnChanges({ readColumnValue }: SimpleChanges) {
    if (readColumnValue) {
      this.value = this.column.value;
    }
  }

  private getLocationPermission() {
    this.userId = this.userInfoResolver.resolve().id;
    return this.adminService.getLocationPermissionForUser(this.userId).pipe(
      tap(locationPermission => {
        this.locationPermission = locationPermission;
      })
    );
  }

  private get isDropdown() {
    const { inputType, lookupCategory, dataType } = this.column;
    return inputType === 'Dropdown' || !!lookupCategory || dataType === 'month';
  }

  private setUpDropdowns() {
    const { lookupCategory, values } = this.column;
    if (values && values.length) {
      return this.initOptions(values, lookupCategory);
    }
    if (lookupCategory) {
      return this.initAsyncOptions(lookupCategory);
    }
  }

  private initAsyncOptions(lookUpCategory: string) {
    this.state = 'shared.loading';
    this.lookupRef
      .loadDataFor(lookUpCategory)
      .pipe(finalize(() => (this.state = '')))
      .subscribe(values => this.initOptions(values, lookUpCategory));
  }

  private initOptions(values: DataObject[], lookupCategory: string) {
    if (lookupCategory.includes('confidentiality')) {
      this.getLocationPermission().subscribe(locationPermission => {
        this.userConfidentialityLevel = String(locationPermission[0].confidentialityTypeId - 1);
        values.forEach(val => {
          val.disabled = this.userConfidentialityLevel < this.value && val.code < this.value;
        });
      });
    } else if (lookupCategory.includes('naics')) {
      // TECH DEBT (Edmundo): Empty value should not come from the backend
      //  Check the possibility of using the record-naics-input.component
      //  inside the edit-box-field.component.
      values = values.filter(({ value }) => value !== '(empty)');
    }
    this.values = values || [];
  }

  emitChange(value) {
    const { field } = this.column;
    if ((this.column.required && value != null) || !this.column.required) {
      this.modified.emit({ field, value, column: this.column });
    }
  }

  emitCustomChanges(id: number, change) {
    if (this.column.columnId === id && this.column.required) {
      const { field } = this.column;
      this.column.value = change.value;
      this.modified.emit({ field, value: change.value, column: this.column });
    }
  }
}
